import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

function Aside() {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const location = useLocation();

  const [nombre, setNombre] = useState("");
  const [perfil, setPerfil] = useState("");
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    if (!cookies.get("idUsuario")) {
      navigate("/");
    } else {
      setNombre(cookies.get("nombresApellidos") || "");
      setPerfil(cookies.get("perfil") || "");
    }
  }, [location]);

  const cerrarSesion = () => {
    cookies.remove("idUsuario", { path: "/" });
    cookies.remove("nombreUsuario", { path: "/" });
    cookies.remove("nombresApellidos", { path: "/" });
    cookies.remove("correo", { path: "/" });
    cookies.remove("perfilId", { path: "/" });
    cookies.remove("perfil", { path: "/" });
    navigate("/");
  };

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };

  const esAdmin = perfil === "Administrador";

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      {/* Brand Logo */}
      <NavLink to="/" className="brand-link">
        <img
          src="../dist/img/logo2.png"
          alt="Logo"
          className="brand-image"
        />
        <span className="brand-text font-weight-light">CRM - PWS</span>
      </NavLink>

      {/* Sidebar */}
      <div className="sidebar">
        {/* User Panel */}
        <div className="user-panel mt-3 pb-3 mb-3 d-flex align-items-center">
          <div className="image">
            <img
              src="dist/img/usuario.png"
              className="img-circle elevation-2"
              alt="User"
            />
          </div>
          <div className="info">
            <span className="d-block text-white">{formatName(nombre)}</span>
            <span style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.55)" }}>
              {perfil}
            </span>
          </div>
        </div>

        {/* Menu */}
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" role="menu">

            {/* Inicio */}
            <li className="nav-item">
              <NavLink to="/inicio" className="nav-link">
                <i className="nav-icon fas fa-tachometer-alt" />
                <p>Inicio</p>
              </NavLink>
            </li>

            {/* Historial Chats */}
            <li className="nav-item">
              <NavLink to="/historial_chats" className="nav-link">
                <i className="fas fa-tags nav-icon"></i>
                <p>Historial Chats</p>
              </NavLink>
            </li>

            {/*PROSPECTOS
            <li className="nav-item">
              <NavLink to="/prospectos" className="nav-link">
                <i className="fas fa-user-plus nav-icon"></i>
                <p>Prospectos</p>
              </NavLink>
            </li>*/}

            {/*SUSCRIPTORES
            {esAdmin && (
            <li className="nav-item">
              <NavLink to="/suscriptores" className="nav-link">
                <i className="fas fa-address-card nav-icon"></i>
                <p>Suscriptores</p>
              </NavLink>
            </li>
            )}*/}

            {/* Facturación */}
            {/* <li className="nav-item">
              <NavLink to="/facturacion" className="nav-link">
                <i className="fas fa-file-invoice-dollar nav-icon"></i>
                <p>Facturación</p>
              </NavLink>
            </li> */}

            {/* Configuración — solo Admin */}
            {esAdmin && (
              <li className={`nav-item has-treeview ${openMenu === "config" ? "menu-open" : ""}`}>
                <a href="#!" className="nav-link" onClick={() => toggleMenu("config")}>
                  <i className="nav-icon fas fa-cogs" />
                  <p>
                    Configuración
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <NavLink to="/telefonos_notificacion" className="nav-link">
                      <i className="fas fa-phone-square nav-icon" />
                      <p>Teléfonos Notificación</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/gestion_usuarios" className="nav-link">
                      <i className="fas fa-user-cog nav-icon"></i>
                      <p>Usuarios del sistema</p>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            {/* Cerrar sesión */}
            <li className="nav-item" style={{ marginTop: "auto", paddingTop: "1rem" }}>
              <a href="#!" className="nav-link" onClick={cerrarSesion}>
                <i className="nav-icon fas fa-sign-out-alt" />
                <p>Cerrar sesión</p>
              </a>
            </li>

          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Aside;